import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { AuditLogData } from "../../types/AuditLog";

import { toast } from "react-toastify";
import { initialParamData, ParamData } from "../../types/Param";
import {
  getEntityListData,
  getEntityLogData,
  getUserListData,
  getUserLogData,
} from "../../api/AuditApi";
import UserLog from "./UserLog";
import EntityLog from "./EntityLog";
import WeeklyActivityPieChart from "../../components/charts/dailyaudit/DailyAudit";
import LoginTrendCard from "../../components/charts/logintrend/LoginTrendCard";
import SucceededFailedLoginCard from "../../components/charts/succeededfailed/SucceededFailedLoginCard";
import DailyAuditCard from "../../components/charts/dailyaudit/DailyAuditCard";

const AuditReport: React.FC = () => {
  const [userLogData, setUserLogData] = useState<AuditLogData[]>([]);
  const [entityLogData, setEntityLogData] = useState<AuditLogData[]>([]);
  const [users, setUsers] = useState<string[]>([]);
  const [entities, setEntities] = useState<string[]>([]);
  const [paramData, setParamData] = useState<ParamData>(initialParamData);
  const [loading, setLoading] = useState(true); // <-- loading state

  const loadActivitiesData = async () => {
    setLoading(true);

    if (paramData.user && paramData.user.trim() !== "") {
      const userData = await getUserLogData(paramData);
      if (userData.length < 1) {
        toast.error("Failed to  get user log data");
        setLoading(false);
        return;
      }
      await setUserLogData(userData);
    }

    if (paramData.entity && paramData.entity.trim() !== "") {
      const entityData = await getEntityLogData(paramData);
      if (entityData.length < 1) {
        toast.error("Failed to  get entity log data");
        setLoading(false);
        return;
      }
      // alert(JSON.stringify(entityData));
      await setEntityLogData(entityData);
    }

    setLoading(false);
  };

  const loadListData = async () => {
    setLoading(true);

    const users = await getUserListData();
    await setUsers(users);

    const entities = await getEntityListData();
    await setEntities(entities);
    setLoading(false);
  };

  const onSubmit = async () => {
    await loadActivitiesData();
  };

  useEffect(() => {
    loadListData();
  }, []);

  return (
    <div>
      <Box>
        {/* === Responsive Cards for Charts/Widgets === */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr", // Mobile: 1 card per row
              sm: "1fr 1fr", // Tablets: 2 cards per row
              md: "1fr 1fr 1fr", // Desktop: 3 cards per row
            },
            gap: 2,
            mb: 3,
          }}
        >
          {/* Card 1 */}
          <Box
            sx={{
              bgcolor: "white",
              p: 2,
              borderRadius: 2,
              boxShadow: 2,
              minHeight: 180,
            }}
          >
            <LoginTrendCard />
          </Box>

          {/* Card 2 */}
          <Box
            sx={{
              bgcolor: "white",
              p: 2,
              borderRadius: 2,
              boxShadow: 2,
              minHeight: 180,
            }}
          >
            <DailyAuditCard />
          </Box>

          {/* Card 3 */}
          <Box
            sx={{
              bgcolor: "white",
              p: 2,
              borderRadius: 2,
              boxShadow: 2,
              minHeight: 180,
            }}
          >
            <SucceededFailedLoginCard />
          </Box>
        </Box>

        {/* Existing components */}
        <UserLog
          users={users}
          activities={userLogData}
          paramData={paramData}
          setParamData={setParamData}
          onSubmit={onSubmit}
        />

        <EntityLog
          entities={entities}
          activities={entityLogData}
          paramData={paramData}
          setParamData={setParamData}
          onSubmit={onSubmit}
        />
      </Box>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress />
        </Box>
      )}
    </div>
  );
};

export default AuditReport;
